export const PEOPLE_LOG_FETCH = 'PEOPLE_LOG_FETCH'
export const PEOPLE_LOG_FETCH_SUCCEEDED = 'PEOPLE_LOG_FETCH_SUCCEEDED'
export const PEOPLE_LOG_FETCH_FAILED = 'PEOPLE_LOG_FETCH_FAILED'

export const loadPeopleLog = () =>
  ({ type: PEOPLE_LOG_FETCH, payload: {} })

export const peopleLogFetchSucceeded = logs =>
  ({ type: PEOPLE_LOG_FETCH_SUCCEEDED, payload: logs })

export const peopleLogFetchFailed = () =>
  ({ type: PEOPLE_LOG_FETCH_FAILED, payload: {} })



// WEBPACK FOOTER //
// ./src/actions/activities.jsx